
var $body,
    $toggleMenu;


$(document).ready(function($) {

    console.log('%cLinku Novio',"font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px");

    $body = $('body');
    $toggleMenu = $("#toggleMenu");


    $toggleMenu.click(function(){
        $body.toggleClass('show-menu');
    });

    window.addEventListener('CookiebotOnAccept', function (e) {
        if (Cookiebot.consent.preferences)
        {
            setCookie('first_party_cookie_testje', 'Y', 30);
        }
    }, false);

});

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}
